// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bs-primary: #263f86;
  --bs-primary-rgb: 38, 63, 134;
  --bs-link-color: #263f86;
  --bs-link-hover-color: #1e3474;
  --tmis-primary: #263f86;
  --tmis-primary-hover: #1e3474;
  --tmis-primary-active: #182a60;
  --tmis-primary-soft: #e7edff;
  --tmis-focus-ring: rgba(38, 63, 134, 0.22);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: var(--tmis-primary);
  --bs-btn-border-color: var(--tmis-primary);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: var(--tmis-primary-hover);
  --bs-btn-hover-border-color: var(--tmis-primary-hover);
  --bs-btn-focus-shadow-rgb: 38, 63, 134;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: var(--tmis-primary-active);
  --bs-btn-active-border-color: var(--tmis-primary-active);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6477ab;
  --bs-btn-disabled-border-color: #6477ab;
}

.btn-outline-primary {
  --bs-btn-color: var(--tmis-primary);
  --bs-btn-border-color: var(--tmis-primary);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: var(--tmis-primary);
  --bs-btn-hover-border-color: var(--tmis-primary);
  --bs-btn-focus-shadow-rgb: 38, 63, 134;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: var(--tmis-primary-active);
  --bs-btn-active-border-color: var(--tmis-primary-active);
  --bs-btn-disabled-color: #6477ab;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6477ab;
}

.bg-primary,
.text-bg-primary,
.badge.bg-primary {
  background-color: var(--tmis-primary) !important;
  color: #fff !important;
}

.text-primary { color: var(--tmis-primary) !important; }
.border-primary { border-color: var(--tmis-primary) !important; }
.link-primary { color: var(--tmis-primary) !important; }
.link-primary:hover,
.link-primary:focus { color: var(--tmis-primary-hover) !important; }

.form-check-input:checked {
  border-color: var(--tmis-primary);
  background-color: var(--tmis-primary);
}

.form-check-input:focus,
.form-control:focus,
.form-select:focus {
  border-color: #6077b4;
  box-shadow: 0 0 0 0.25rem var(--tmis-focus-ring);
}

.dropdown-item.active,
.dropdown-item:active,
.list-group-item.active,
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  border-color: var(--tmis-primary);
  background-color: var(--tmis-primary);
  color: #fff;
}

.page-item.active .page-link,
.pagination .active > .page-link {
  border-color: var(--tmis-primary);
  background-color: var(--tmis-primary);
  color: #fff;
}

.page-link {
  color: var(--tmis-primary);
}

.page-link:hover {
  color: var(--tmis-primary-hover);
  background-color: var(--tmis-primary-soft);
}

.progress-bar { background-color: var(--tmis-primary); }

.alert-primary {
  --bs-alert-color: #172554;
  --bs-alert-bg: #eef2ff;
  --bs-alert-border-color: #cbd7f7;
  --bs-alert-link-color: #172554;
}

.table-primary {
  --bs-table-color: #172033;
  --bs-table-bg: #e7edff;
  --bs-table-border-color: #ccd6ee;
  --bs-table-striped-bg: #dce4f7;
  --bs-table-hover-bg: #d4def4;
}

.spinner-border.text-primary,
.spinner-grow.text-primary {
  color: var(--tmis-primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/BootstrapTmisTheme.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,0CAA0C;EAC1C,0BAA0B;EAC1B,4CAA4C;EAC5C,sDAAsD;EACtD,sCAAsC;EACtC,2BAA2B;EAC3B,8CAA8C;EAC9C,wDAAwD;EACxD,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,0BAA0B;EAC1B,sCAAsC;EACtC,gDAAgD;EAChD,sCAAsC;EACtC,2BAA2B;EAC3B,8CAA8C;EAC9C,wDAAwD;EACxD,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;;;EAGE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA,gBAAgB,qCAAqC,EAAE;AACvD,kBAAkB,4CAA4C,EAAE;AAChE,gBAAgB,qCAAqC,EAAE;AACvD;sBACsB,2CAA2C,EAAE;;AAEnE;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;;;EAGE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;;;;EAKE,iCAAiC;EACjC,qCAAqC;EACrC,WAAW;AACb;;AAEA;;EAEE,iCAAiC;EACjC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA,gBAAgB,qCAAqC,EAAE;;AAEvD;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;EAEE,qCAAqC;AACvC","sourcesContent":[":root {\n  --bs-primary: #263f86;\n  --bs-primary-rgb: 38, 63, 134;\n  --bs-link-color: #263f86;\n  --bs-link-hover-color: #1e3474;\n  --tmis-primary: #263f86;\n  --tmis-primary-hover: #1e3474;\n  --tmis-primary-active: #182a60;\n  --tmis-primary-soft: #e7edff;\n  --tmis-focus-ring: rgba(38, 63, 134, 0.22);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: var(--tmis-primary);\n  --bs-btn-border-color: var(--tmis-primary);\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: var(--tmis-primary-hover);\n  --bs-btn-hover-border-color: var(--tmis-primary-hover);\n  --bs-btn-focus-shadow-rgb: 38, 63, 134;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: var(--tmis-primary-active);\n  --bs-btn-active-border-color: var(--tmis-primary-active);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #6477ab;\n  --bs-btn-disabled-border-color: #6477ab;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: var(--tmis-primary);\n  --bs-btn-border-color: var(--tmis-primary);\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: var(--tmis-primary);\n  --bs-btn-hover-border-color: var(--tmis-primary);\n  --bs-btn-focus-shadow-rgb: 38, 63, 134;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: var(--tmis-primary-active);\n  --bs-btn-active-border-color: var(--tmis-primary-active);\n  --bs-btn-disabled-color: #6477ab;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #6477ab;\n}\n\n.bg-primary,\n.text-bg-primary,\n.badge.bg-primary {\n  background-color: var(--tmis-primary) !important;\n  color: #fff !important;\n}\n\n.text-primary { color: var(--tmis-primary) !important; }\n.border-primary { border-color: var(--tmis-primary) !important; }\n.link-primary { color: var(--tmis-primary) !important; }\n.link-primary:hover,\n.link-primary:focus { color: var(--tmis-primary-hover) !important; }\n\n.form-check-input:checked {\n  border-color: var(--tmis-primary);\n  background-color: var(--tmis-primary);\n}\n\n.form-check-input:focus,\n.form-control:focus,\n.form-select:focus {\n  border-color: #6077b4;\n  box-shadow: 0 0 0 0.25rem var(--tmis-focus-ring);\n}\n\n.dropdown-item.active,\n.dropdown-item:active,\n.list-group-item.active,\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  border-color: var(--tmis-primary);\n  background-color: var(--tmis-primary);\n  color: #fff;\n}\n\n.page-item.active .page-link,\n.pagination .active > .page-link {\n  border-color: var(--tmis-primary);\n  background-color: var(--tmis-primary);\n  color: #fff;\n}\n\n.page-link {\n  color: var(--tmis-primary);\n}\n\n.page-link:hover {\n  color: var(--tmis-primary-hover);\n  background-color: var(--tmis-primary-soft);\n}\n\n.progress-bar { background-color: var(--tmis-primary); }\n\n.alert-primary {\n  --bs-alert-color: #172554;\n  --bs-alert-bg: #eef2ff;\n  --bs-alert-border-color: #cbd7f7;\n  --bs-alert-link-color: #172554;\n}\n\n.table-primary {\n  --bs-table-color: #172033;\n  --bs-table-bg: #e7edff;\n  --bs-table-border-color: #ccd6ee;\n  --bs-table-striped-bg: #dce4f7;\n  --bs-table-hover-bg: #d4def4;\n}\n\n.spinner-border.text-primary,\n.spinner-grow.text-primary {\n  color: var(--tmis-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
